import { CanDeactivateFn } from '@angular/router';
import { ImportadorDadosComponent } from '@pages/importador-dados/importador-dados.component';

export const pendingChangesGuard: CanDeactivateFn<ImportadorDadosComponent> = (component) => {
  if (component.isUploadingFile) {
    return !confirm(component.uploadingFileMessage);
  }
  return true;
};
